import React, { useState } from "react";
import ReportsHeader from "../../../components/HecoReports/ReportHeader/ReportHeader";
import TreeMapGraph from "../../../components/HecoReports/TreeMap/Graph/TreeMapGraph";
import TreeMapLegend from "../../../components/HecoReports/TreeMap/Legend/TreeMapLegend";
import TreemapTable from "../../../components/HecoReports/TreeMap/Table/TreemapTable";

import "./treemap.css";
import { Navigate } from "react-router-dom";

/* 
  Parent component for all treemap elements
 */

function TreeMap() {

  // Initialising usestates
  const [selectedNodeName, setSelectedNodeName] = useState("All");
  const [qualityFilter, setQualityFilter] = useState("All");
  const timestamp = localStorage.getItem("timestamp");

  // Handling the category filter (i.e., start, pathway, comparator)
  const handleNodeSelected = (nodeName) => {
    setSelectedNodeName(nodeName);
    setQualityFilter("All"); //reset the quality filter when a node in the graph is clicked 
  };

  // Handling the quality filter (i.e.,  low, medium, high)
  const handleQualityFilter = (quality) => {
    setQualityFilter(quality === qualityFilter ? "All" : quality);
  };

  return (
    <>
     {/* Generate report if there is a timestamp, otherwise redirects to input form */}
    {timestamp ? (
      <>
       <ReportsHeader defaultType={"Treemap"}/>
      <div className="tree-map-body">
        <div className="container-fill">
          <div className="sample-flex-rows">

            {/* Graph callback prop  obtains category filter */}
            <TreeMapGraph 
            onNodeSelected={handleNodeSelected} 
            resetQualityFilter={()=> setQualityFilter("All")}
            />
          </div>
        </div>

        {/* Legend callback prop obtains quality filter */}
        <TreeMapLegend
          onQualityFilterChange={handleQualityFilter}
          qualityFilter={qualityFilter}
        />

        {/* Table uses both category and quality filter*/}
        <TreemapTable
          selectedNodeName={selectedNodeName}
          qualityFilter={qualityFilter}
        />
        </div>
      </>
    ):
    (
      <Navigate to="/inputform" />
    )}
     
    </>
  );
}

export default TreeMap;